export default __webpack_public_path__ + "static/media/idealProtectExtra.64df5923.jpg";